function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleAdultFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.097 29.872H6.903a1 1 0 01-1-1c0-4.948 2.062-9.45 5.382-11.747a1 1 0 111.138 1.643c-2.57 1.78-4.243 5.209-4.489 9.104h16.132c-.246-3.895-1.919-7.325-4.49-9.104a.999.999 0 111.138-1.643c3.321 2.297 5.383 6.799 5.383 11.747a1 1 0 01-1 1zM16 4.127a4.6 4.6 0 00-4.594 4.594A4.6 4.6 0 0016 13.315a4.6 4.6 0 004.594-4.594A4.6 4.6 0 0016 4.127zm0 11.188A6.602 6.602 0 019.406 8.72 6.601 6.601 0 0116 2.127a6.601 6.601 0 016.594 6.594A6.602 6.602 0 0116 15.315z",
    fill: props.color
  }));
}

export default SvgIconPeopleAdultFilled;